import type {SelectOptionItem} from '@yandex-delivery/blocks'
import type {
  LocationDetectedVariant,
  OffersInfoLastMilePolicy,
  PickupStation,
  PickupStationType,
} from '@yandex-delivery/types/logistic-dispatcher/external-api'

export * from '@yandex-delivery/types/logistic-dispatcher/external-api'
export const enum SourcePointDeliveryMethod {
  Station = 'station',
  DropOffPoint = 'dropOffPoint',
}

export const enum DestinationPointDeliveryMethod {
  Address = 'address',
  PickUpPoint = 'pickUpPoint',
}

import type {Filter} from './consts'

export type FilterFunction = (value: PickupStation, type?: PickupStationType | boolean, ...args: []) => boolean

export type Props = {
  isOpen: boolean
  isPending: boolean
  onCitySelect: (city?: LocationDetectedVariant) => void
  selectedPoint?: PickupStation
  center?: [number, number]
  zoom?: number
  onClose: VoidFunction
  points: SelectOptionItem<PickupStation>[]
  pointType: SourcePointDeliveryMethod.DropOffPoint | DestinationPointDeliveryMethod.PickUpPoint
  onPointSelect: (point?: PickupStation) => void
  selectedPointCity?: string
}

export type FiltersValues = {
  [Filter.POST_PAYMENT]: boolean
  [Filter.POINT_TYPE]: PickupStationType
}

export type PaymentMethod = 'already_paid' | 'cash_on_receipt' | 'card_on_receipt' | 'cashless'

export type NddClaimOffersInfoQuery = {
  last_mile_policy: OffersInfoLastMilePolicy | string
}

export type ParcelSize = 'small' | 'medium' | 'large' | 'custom'

export type ParcelDimensions = {
  height: number
  length: number
  weight: number
  width: number
}
